import { useEffect, useState } from "react";

/** Phone-sized screens: the width mobile.css switches layouts at. Keep the two in step. */
export const PHONE = "(max-width: 700px)";

const matches = (query: string) =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(query).matches;

/** Whether a CSS media query matches, kept up to date as the window changes (e.g. a phone turned sideways). */
export function useMediaQuery(query: string): boolean {
  const [on, setOn] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(query);
    const update = () => setOn(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [query]);
  return on;
}
